import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ActionSheetController, ModalController } from "@ionic/angular";
import { ViewPaymentDetailModel } from "src/app/model/ViewPaymentDetailModel";
import { ViewApplicationService } from "src/app/services/view-application.service";
import { ViewPdfComponent } from "../../view-pdf/view-pdf.component";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ViewProfileDocumentComponent } from "src/app/audit-trail/profile-details/view-profile-document/view-profile-document.component";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";
import { Page } from "src/app/model/Page";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import moment from "moment";
import { RefundRejectComponent } from "../reject-case/refund-reject-case.component";
import { RefundCloseComponent } from "../close-case/refund-close-case.component";
import { ReopenCaseComponent } from "../reopen-case/reopen-case.component";

@Component({
  selector: "app-secure-view-payment-refund-dtl",
  templateUrl: "./view-payment-refund-dtl.component.html",
  styleUrls: ["./view-payment-refund-dtl.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ViewPaymentRefundDtlComponent implements OnInit {
  data: ViewPaymentDetailModel;
  page: Page<ViewPaymentDetailModel>;
  dataSource: MatTableDataSource<ViewPaymentDetailModel> =
    new MatTableDataSource();
  applicationNo: number;
  statusId: string;
  oldBankName: string;
  oldBranchName: string;
  oldIfsc: string;
  refundAmount: string;
  amountApproveRefundAmount: string;
  oldAccountNo: string;
  isLoading: boolean = false;
  manualRejectedQuestions: any[] = [];
  documents: any[] = [];
  verifiedStatus: any[] = [];
  documentName: string = "";
  profileDetails: any[] = [];
  areQuestionsNotAnswered: boolean;
  activeLang: string = "en";
  viewEnMr: string = "View";
  cancelEnMr: string = "Cancel";
  editEnMr: string = "Edit";
  progressSpinnerDialog: any = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isSearchDisabled: boolean = false;
  selectedFile: File;
  selectedFile1: File;
  orderDocumentFile: string | ArrayBuffer;
  orderDocumentFileFOrView: string | ArrayBuffer;
  orderDocument: string;
  orderFile: string;
  cancelType: string = "REFUND";
  displayedColumns: string[] = [
    "id",
    "installmentType",
    "installmentAmount",
    "delayDays",
    "interestAmount",
    // "totalAmountToBePaid",
    "totalwithinterestAmount",
    "settlementAmount",
    "pendingBalanceAmount",
    "onlinePaymentDate",
    // "settlementDate",
    // "balanceAmount",
    "transactionId",
    "utrNo",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  // isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  showtable: number = 5000001;
  source: string;
  paymentApprove: string;
  maxDate: Date;
  currentDate: Date = new Date();
  form: FormGroup = new FormGroup({});
  formBank: FormGroup = new FormGroup({});
  constructor(
    private route: ActivatedRoute,
    private paymentSettlementService: PaymentSettlementService,
    private modalCtrl: ModalController,
    private auditTrailService: AuditTrailService,
    private router: Router,
    public actionSheetController: ActionSheetController,
    private dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private _snackBar: MatSnackBar
  ) {
    {
      this.maxDate = moment(this.currentDate).add(0, "day").toDate();
    }
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      paymentApprove: new FormControl(),
      chequeDD: new FormControl(),
      refundAmount: new FormControl(),
      AmountApproveRefundAmount: new FormControl(),
      finalRefundAmount: new FormControl(),
      utrNo: new FormControl(),
      file2: new FormControl(null, Validators.required),
      refundPaymentDate: new FormControl(null, Validators.required),
    });
    this.formBank = new FormGroup({
      bankName: new FormControl(),
      bankAccountNo: new FormControl(),
      branchName: new FormControl(),
      ifsc: new FormControl(),
    });
    this.loadData();
  }

  loadData() {
    this.route.params.subscribe((params: Params) => {
      this.applicationNo = +params["applicationNo"];
      this.statusId = params["paymentStatus"];

      this.source = params["source"];

      console.log("source", this.source, this.statusId);

      this.isLoading = true;
      this.paymentSettlementService
        .viewaymentRefundDetail(this.applicationNo, this.statusId)
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.data = data;
              ((this.oldBankName = data.bankName),
              (this.oldAccountNo = data.bankAccountNo),
              (this.oldBranchName = data.branchName),
              (this.oldIfsc = data.ifsc),
              (this.refundAmount = data.refundAmount),
              (this.amountApproveRefundAmount =
                data.amountApproveRefundAmount)),
                this.formBank.patchValue({
                  bankName: data.bankName,
                  bankAccountNo: data.bankAccountNo,
                  branchName: data.branchName,
                  ifsc: data.ifsc,
                });
              this.form.patchValue({
                refundAmount: data.refundAmount,
              });
            } else {
              this.paymentSettlementService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.isLoading = false;
            this.paymentSettlementService.errorToast(
              error?.error?.errorMessage || error?.error?.message
            );
          }
        );
      this.paymentSettlementService
        .getPaymentRefundDetailsList(this.applicationNo)
        .subscribe(
          (page: any) => {
            this.isLoading = false;
            console.log("Page ", page);
            this.page = page;
            if (page !== null && page !== "") {
              this.dataSource = new MatTableDataSource(page);
            } else {
              this.isLoading = false;
              this.paymentSettlementService.errorToast(page.errorMessage);
            }
            // setTimeout(() => {
            //   this.paginator.pageIndex = this.currentPage;
            //   this.paginator.length = page.totalElements;
            // });
            this.isSearchDisabled = false;
          },
          (error) => {
            console.log(error);
            this.isLoading = false;
            this.isSearchDisabled = false;
          }
        );
    });
  }
  onFileSelect(event) {
    if (event.target.files[0].size < 2 * 1024 * 1024) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile && this.selectedFile.type === "application/pdf") {
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
          this.orderDocumentFile = reader.result;
          this.orderDocumentFileFOrView = this.orderDocumentFile;
          const fileNameParts = this.selectedFile.name.split(".");
          this.orderFile = this.selectedFile.name;
          const fileNameWithoutExtension = fileNameParts[0];
          this.orderDocument = fileNameWithoutExtension;
        };
      } else {
        this.selectedFile = null;
        this.orderDocumentFile = null;
        this._snackBar.open("Please select a valid PDF file.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this.selectedFile = null;
      this.orderDocumentFile = null;

      this._snackBar.open("File size exceeds 2MB.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
    }
  }
  validateOrderDocFile() {
    return typeof this.orderDocumentFile === "string" ? true : false;
  }
  onAccountFileSelect(event) {
    if (event.target.files[0].size < 2 * 1024 * 1024) {
      this.selectedFile1 = event.target.files[0];
      if (this.selectedFile1 && this.selectedFile1.type === "application/pdf") {
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile1);
        reader.onload = () => {
          this.orderDocumentFile = reader.result;
          this.orderDocumentFileFOrView = this.orderDocumentFile;
          const fileNameParts = this.selectedFile1.name.split(".");
          this.orderFile = this.selectedFile1.name;
          const fileNameWithoutExtension = fileNameParts[0];
          this.orderDocument = fileNameWithoutExtension;
        };
      } else {
        this.selectedFile1 = null;
        this.orderDocumentFile = null;
        this._snackBar.open("Please select a valid PDF file.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this.selectedFile1 = null;
      this.orderDocumentFile = null;

      this._snackBar.open("File size exceeds 2MB.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
    }
  }
  validateAccountOrderDocFile() {
    return typeof this.orderDocumentFile === "string" ? true : false;
  }
  showAsFile() {
    asFile: String;
    this.isLoading = true;
    this.paymentSettlementService
      .fetchAsFile("asFile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "16AS File",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.data?.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            this.paymentSettlementService.errorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          this.paymentSettlementService.errorToast("Unable to fetch As File");
        }
      );
  }
  onCheckboxCheck(e: any) {
    if (e.target) {
    }
  }
  onchequeDDCheck(e: any) {
    if (e.target) {
    }
  }
  showForm16BFile() {
    asFile: String;
    this.isLoading = true;
    this.paymentSettlementService
      .fetchForm16BFile("asFile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Form16B File",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.data?.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            this.paymentSettlementService.errorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          this.paymentSettlementService.errorToast("Unable to fetch As File");
        }
      );
  }

  showQbFile() {
    asFile: String;
    this.isLoading = true;
    this.paymentSettlementService
      .fetchQbFile("asFile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;

          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Qb File",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.data?.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            this.paymentSettlementService.errorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          this.paymentSettlementService.errorToast("Unable to fetch As File");
        }
      );
  }

  showChallanfile() {
    asFile: String;
    this.isLoading = true;
    this.paymentSettlementService
      .fetchChallanFile("asFile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Challan File",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.data?.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            this.paymentSettlementService.errorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          this.paymentSettlementService.errorToast("Unable to fetch As File");
        }
      );
  }

  statusFiles(status: any) {
    if (!this.data.form16bFile) {
      return this._snackBar.open("FORM16B file is required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    this.isLoading = true;
    this.paymentSettlementService
      .statusFile(status, this.applicationNo.toString())
      .subscribe((data) => {
        this.isLoading = false;
        this.loadData();
        console.log(data, "fromStatus files API");
        this._snackBar.open("TDS Certificate Approved", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "success-toast",
          duration: 3 * 1000,
        });
      });
  }
  showOrderDocumentfile() {
    appealdocfile: String;
    this.isLoading = true;
    this.paymentSettlementService
      .fetchRefundFileUploadByClerk("orderfile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Order Letter",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  accounntApprove(status: any) {
    if (!this.form.value.paymentApprove) {
      return this._snackBar.open("Please Select  Check Box", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    if (!this.validateOrderDocFile()) {
      return this._snackBar.open("Order Document File Is Required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 10 * 1000,
      });
    }
    if (
      confirm(
        "Are you sure you want to forward this applicant to the account officer for refund process -" +
          this.applicationNo.toString() +
          "."
      )
    ) {
      let payload: any = {
        status: status,
        applicationNo: this.applicationNo.toString(),
        newBankName: this.formBank.value.bankName,
        oldBankName: this.oldBankName,
        oldBranchName: this.oldBranchName,
        oldIfsc: this.oldIfsc,
        oldAccountNo: this.oldAccountNo,
        newBranchName: this.formBank.value.branchName,
        newIfsc: this.formBank.value.ifsc,
        newAccountNo: this.formBank.value.bankAccountNo,
        stutusId: this.statusId,
        orderFile: this.orderFile,
        orderDocumentFile: this.orderDocumentFile,
      };

      this.isLoading = true;
      this.paymentSettlementService
        .accountRefundApproveByClerk(payload)
        .subscribe((data) => {
          this.isLoading = false;
          this.loadData();

          this._snackBar.open("Clerk  Approved", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
          });
          this.router.navigate(["/secure", "payment-refund"]);
          this.isLoading = true;
        });
    }
  }

  async closeByClerk() {
    const modal = await this.modalCtrl.create({
      component: RefundCloseComponent,
      componentProps: {
        pan: this.applicationNo,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (role === "CLOSE") {
      if (
        confirm(
          "Are you sure you want to CLOSE this applicant  -" +
            this.applicationNo.toString() +
            "."
        )
      ) {
        let payload: any = {
          closeRemark: data,
          status: this.statusId,
          applicationNo: this.applicationNo.toString(),

          stutusId: this.statusId,
        };

        this.isLoading = true;
        this.paymentSettlementService
          .accountRefundCloseByClerk(payload)
          .subscribe((data) => {
            this.isLoading = false;
            this.loadData();

            this._snackBar.open("Clerk  CLOSE Case Successfully", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "success-toast",
              duration: 3 * 1000,
            });
            this.router.navigate(["/secure", "payment-refund"]);
            this.isLoading = true;
          });
      }
    }
  }
  accounntForward(status: any) {
    if (!this.form.value.paymentApprove) {
      return this._snackBar.open("Please Select  Check Box", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    if (!this.form.value.refundAmount) {
      return this._snackBar.open("Refund Amount Is Required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    if (!this.validateAccountOrderDocFile()) {
      return this._snackBar.open("Order Document File Is Required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 10 * 1000,
      });
    }
    if (
      confirm(
        "Are you sure you want to forward this applicant to the Expenditure officer  for refund process -" +
          this.applicationNo.toString() +
          "."
      )
    ) {
      let payload: any = {
        status: status,
        applicationNo: this.applicationNo.toString(),
        systemRefundAmount: this.refundAmount,
        refundAmount: this.form.value.refundAmount,
        stutusId: this.statusId,
        orderFile: this.orderFile,
        orderDocumentFile: this.orderDocumentFile,
      };

      this.isLoading = true;
      this.paymentSettlementService
        .accountRefundApproveByAccount(payload)
        .subscribe((data) => {
          this.isLoading = false;
          this.loadData();

          this._snackBar.open("Account Officer  Approved", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
          });
          this.router.navigate(["/secure", "payment-refund"]);
          this.isLoading = true;
        });
    }
  }
  async reject() {
    const modal = await this.modalCtrl.create({
      component: RefundRejectComponent,
      componentProps: {
        pan: this.applicationNo,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (role === "reject") {
      console.log("DATA", data);
      // new API to update to update reject reasone
      let payload: any = {
        rejectRemark: data,
        applicationNo: this.applicationNo.toString(),
        stutusId: this.statusId,
      };
      this.isLoading = true;
      this.paymentSettlementService
        .rejectedPaymentRefund(payload)
        .subscribe((data) => {
          this.isLoading = false;

          this._snackBar.open("PAYMENT REFUND REJECTED", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "danger-toast",
            duration: 3 * 1000,
          });
          if (data.status == "SUCCESS") {
            this.router.navigate(["/secure", "payment-refund"]);
            this.loadData();
          }
        });
      this.isLoading = true;

      // this.onSubmit('REJECTED', data);
    }
  }
  async reopenCase() {
    const modal = await this.modalCtrl.create({
      component: ReopenCaseComponent,
      componentProps: {
        pan: this.applicationNo,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (role === "reopen") {
      console.log("DATA", data);
      // new API to update to update reopen reasone
      let payload: any = {
        reopenRemark: data,
        applicationNo: this.applicationNo.toString(),
        stutusId: this.statusId,
      };
      this.isLoading = true;
      this.paymentSettlementService
        .reopenPaymentRefund(payload)
        .subscribe((data) => {
          this.isLoading = false;

          this._snackBar.open("PAYMENT REFUND REOPEN", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "danger-toast",
            duration: 3 * 1000,
          });
          if (data.status == "SUCCESS") {
            this.router.navigate(["/secure", "payment-refund"]);
            this.loadData();
          }
        });
      this.isLoading = true;

      // this.onSubmit('REJECTED', data);
    }
  }
  validateRefundPaymentDate() {
    return new Date(this.form.value.refundPaymentDate) < new Date()
      ? true
      : false;
  }
  expendatureAccounntApproved(status: any) {
    if (!this.form.value.paymentApprove) {
      return this._snackBar.open("Please Select  Check Box", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    if (!this.form.value.finalRefundAmount) {
      return this._snackBar.open("Refunded Amount Is Required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    if (!this.form.value.utrNo) {
      return this._snackBar.open("UTR NO. Is Required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    if (!this.form.value.refundPaymentDate) {
      return this._snackBar.open("Please enter payment refund date", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    if (
      !this.validateRefundPaymentDate() &&
      this.form.value.refundPaymentDate
    ) {
      this._snackBar.open(
        "Payment refund Date should be grater than  Current Date",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 10 * 1000,
        }
      );

      return;
    }
    // if (!this.validateAccountOrderDocFile()) {
    //   return this._snackBar.open("Order Document File Is Required", "Close", {
    //     horizontalPosition: "right",
    //     verticalPosition: "top",
    //     panelClass: "warning-toast",
    //     duration: 10 * 1000,
    //   });
    // }
    const finalRefundAmount = this.form.value.finalRefundAmount;

    if (this.amountApproveRefundAmount < finalRefundAmount) {
      console.log(
        "this.amountApproveRefundAmount",
        this.amountApproveRefundAmount
      );
      console.log("this.finalRefundAmount", finalRefundAmount);
      return this._snackBar.open(
        "Refund Amount greater than Account Approved Amount",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 5 * 1000,
        }
      );
    }
    if (this.amountApproveRefundAmount > finalRefundAmount) {
      console.log(
        "this.amountApproveRefundAmount",
        this.amountApproveRefundAmount
      );
      console.log("this.finalRefundAmount", finalRefundAmount);
      return this._snackBar.open(
        "Refund Amount Less than Account Approved Amount",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 5 * 1000,
        }
      );
    }
    if (
      confirm(
        "Are you sure to approve this applicant Refund -" +
          this.applicationNo.toString() +
          "."
      )
    )
      console.log(
        "this.form.value.paymentApprove",
        this.form.value.paymentApprove
      );

    console.log("this.form.value.chequeDD", this.form.value.chequeDD);

    {
      let payload: any = {
        status: status,
        applicationNo: this.applicationNo.toString(),
        finalRefundAmount: this.form.value.finalRefundAmount,
        utrNo: this.form.value.utrNo,
        stutusId: this.statusId,
        orderFile: this.orderFile,
        paymentRefundDate: moment(this.form.value.refundPaymentDate).format(
          "DD-MM-YYYY HH:mm:ss"
        ),
        orderDocumentFile: this.orderDocumentFile,
        chequeDD: this.form.value.chequeDD,
      };

      this.isLoading = true;
      this.paymentSettlementService
        .accountRefundApproveByExpendature(payload)
        .subscribe((data) => {
          this.isLoading = false;
          this.loadData();

          this._snackBar.open("Account Officer  Approved", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
          });

          this.router.navigate(["/secure", "payment-refund"]);
          this.isLoading = true;
        });
    }
  }

  redirectToDocumentView() {
    if (this.data && this.data.applicationId) {
      this.router.navigate([
        "/secure",
        "applicant-document-view",
        this.data.applicationId,
        "REFUND",
      ]);
    }
  }
}
